import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../store";
import { ColumnFilterProps, FilterOperator } from "../../types/filters";
import { IconNameEnum } from "../Icon";
import { TextInput, TextInputIconPosition } from "../TextInput";

interface TextFilterProps extends ColumnFilterProps {
  iconName?: IconNameEnum;
}

export const TextFilter: React.FC<TextFilterProps> = ({
  tableName,
  fieldName,
  iconName,
  filterSelectorValue,
  filterUpdateAction,
}) => {
  const value = useSelector((state: RootState) => filterSelectorValue(state, fieldName));
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <TextInput
      placeHolder={t(`${tableName}.filters.${fieldName}`)}
      value={String(value?.value ?? "")}
      icon={iconName}
      iconPosition={TextInputIconPosition.end}
      iconSize={24}
      onChange={(e) => {
        dispatch(
          filterUpdateAction({
            id: fieldName,
            name: fieldName,
            operator: FilterOperator.Contains,
            value: e.target.value,
          })
        );
      }}
    />
  );
};
